<template>
<div class="chapter">
<div class="inner_page">
<h1 class="h1"><a id="page_9">PART I</a></h1><a id="page_9">
<p class="imagec"><img alt="Images" src="images/common1.png"/></p>
<p class="center">Carmarthen, Wales</p>
<p class="center">July 1777</p>
<p class="center1b"><span class="txit">Six years earlier</span></p>
<p class="epip">If you marry a green youth,</p>
<p class="epip">you will cut the sprouting corn;</p>
<p class="epip">and you may find that the harvest</p>
<p class="epip">is too stormy to be borne.</p>
</a><p class="epipc"><a id="page_9">—ANONYMOUS, “STANZAS FOR THE HARP”</a><a id="page_10"></a></p><a id="page_10">
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// part01.vue?4cbef68c